import { useSelector } from "react-redux";
import { Navigate } from "react-router-dom";

/**
 * Sends visitors without a session back to the home page to join or create one. With
 * `orHostKey`, a host with a key gets in between sessions too (their sets); the server's
 * answer about the key is awaited first, so a reload does not bounce them home.
 */
const RequireSession = ({ children, orHostKey = false }) => {
  const code = useSelector((state) => state.session.Code);
  const hasKey = useSelector((state) => state.host.hasKey);
  const hostLoaded = useSelector((state) => state.host.loaded);
  if (code) return children;
  if (orHostKey) {
    if (!hostLoaded) return null;
    if (hasKey) return children;
  }
  return <Navigate to="/" replace />;
};

export default RequireSession;
